<template>
    <div class="modal">
        <div class="blanket" @click="cancel" />
        <div class="modal-container">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    name: 'Modal',
    props: {
        headline: {
            type: String,
            default: '',
            required: false,
            note: 'the text that should be displayed in the headline',
        },
        body: {
            type: String,
            default: '',
            required: false,
            note: 'body text',
        },
        buttonCancelText: {
            type: String,
            default: '',
            required: false,
            note: 'the text that should be displayed on the cancel button',
        },
        buttonConfirmText: {
            type: String,
            default: null,
            required: false,
            note: "the text that should be displayed on the confirm button. Note: If not set, button won't appear",
        },
    },
    mounted() {
        window.addEventListener('keydown', this.keydown)
    },
    beforeDestroy() {
        window.removeEventListener('keydown', this.keydown)
    },
    methods: {
        cancel() {
            this.$emit('cancel')
        },
        confirm() {
            this.$emit('confirm')
        },
        keydown(e) {
            if (e.key === 'Escape') {
                e.preventDefault()
                this.cancel()
            }

            if (e.key === 'Enter') {
                e.preventDefault()
                this.confirm()
            }
        },
        isEmpty(obj) {
            for (let key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    return false
                }
            }
            return true
        },
    },
}
</script>

<style scoped lang="sass">

.modal
    overflow: auto
    overflow-x: hidden
    position: fixed
    z-index: 100
    min-width: 100vw
    min-height: 100vh
    top: 0
    left: 0
    bottom: 0
    right: 0

    .blanket
        width: 100%
        height: 100%
        background-color: rgba($primary-3, 0.2)
        position: fixed
        top: 50%
        left: 50%
        transform: translate(-50%, -50%)
        z-index: 1

    .modal-container
        z-index: 2
        position: absolute
        top: 10%
        left: 50%
        transform: translate(-50%, 0%)
        background-color: white
        border-radius: 10px
        box-shadow: 0px 5px 30px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.1)
        margin-bottom: 100px

        .modal-content
            padding: $m

            .headline-container
                display: flex
                align-items: center
                margin-bottom: $m

                .copy-l
                    color: $neutral-black

                .icon
                    margin-right: $xs

                    &::v-deep
                        svg
                            path
                                stroke: $neutral-3

            .main
                margin-bottom: $m

                .description
                    margin-top: $s

        .action-container
            display: flex
            justify-content: flex-end

            .button + .button
                margin-left: $s

            &.fullwidth
                .button
                    flex: 1
</style>
